import React from 'react'
import { Link } from 'react-router-dom'

const Logo = () => (
  <div className='logo zindex order-md-1 order-2 col-sm-2 col-3 mx-auto mx-sm-0 pr-sm-0'>
    <div className='row align-items-center h-100'>
      <h1 className='col-12 px-0 txt-center txt-md-left logo-header pointer'>
        <Link to='/' title='Ir para a página inicial' className='h-100 d-block pos-absolute w-100' tabIndex='0'>
          <span className='d-none'>{process.env.REACT_APP_TITLE || 'Web Prêmios'}</span>
        </Link>
      </h1>
    </div>
  </div>
)

export default Logo



// WEBPACK FOOTER //
// ./src/App/Header/Logo/Logo.js